import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { License } from 'app/shared/models/license';
import { tr, LocaleDatePipe } from '@kpd/framework-ngx';
import { Permissions } from 'app/shared/services/permissions';

@Component({
  selector: 'app-license-card',
  templateUrl: './license-card.component.html',
})
export class LicenseCardComponent implements OnInit {
  Permissions: typeof Permissions = Permissions;
  @Input()
  license: License;
  @Input()
  selected: boolean;
  @Input()
  loading = false;

  @Output()
  onClickAssigned = new EventEmitter<void>();

  constructor(private datePipe: LocaleDatePipe) {}

  ngOnInit(): void {
    if (!(this.license instanceof License)) {
      this.license = new License(this.license as any);
    }
  }

  getAssignedText(): string {
    return `${this.license.quantityAssigned} ${tr('assigned')}`;
  }
  getAvailableText(): string {
    return `${this.license.quantityAvailable} ${tr('available')}`;
  }
  getTermText(): string {
    return `${tr('Validity')}: ${this.datePipe.transform(this.license.validFromDateTime.toDateString())} ${tr(
      'until',
    )} ${this.datePipe.transform(this.license.validUntilDateTime.toDateString())}`;
  }

  getPurchasedText(): string {
    return `${tr('Purchased on ')} ${this.datePipe.transform(this.license.purchaseDateTime.toDateString())}`;
  }
  getStateText(): string {
    const term = this.license.getValidTermInDays();
    return this.license.isExpired
      ? tr('Expired')
      : this.license.isInvalid
      ? tr('Invalid')
      : this.license.isFuture
      ? tr('Not active yet')
      : this.license.isExpiring
      ? `${tr('Expires in')} ${term} ${term === 1 ? tr(`day`) : tr(`days`)}`
      : '';
  }
  clickAssigned(event: MouseEvent): void {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    this.onClickAssigned.emit();
  }
}
